import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeAreaAction } from '../../reducers/actions';
import { AreaService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_AREA),
    switchMap(action =>
      AreaService.delete(action.area.areaId, store).pipe(
        map(() => removeAreaAction(action.area)),
        catchError(retryAuthentication(action$, 'epics/areas/deleteArea'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/areas/deleteArea.js